import './bmg-error-modal.scss';

import { Trans, useTranslation } from 'react-i18next';

import { Modal } from '@/components/Client/AutoCredit/shared/ui';
import { Button } from '@/components/Shared/ui';

interface IProps {
  isOpened: boolean;
  onCancel: () => void;
  onRetry: () => void;
}

const STEPS = ['step-1', 'step-2'] as const;

const BmgErrorModal: React.FC<IProps> = ({ isOpened, onCancel, onRetry }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('otp-validation.bmg-error-modal.title')}
      className="bmg-error-modal-client"
      onClose={onCancel}
      open={isOpened}
      classNames={{
        container: 'bmg-error-modal-client__content'
      }}
      width={540}
      destroyOnHidden
      mask={{ closable: false }}
    >
      <div className="bmg-error-modal-client__body">
        <p className="bmg-error-modal-client__description">
          {t('otp-validation.bmg-error-modal.description')}
        </p>

        <p className="bmg-error-modal-client__steps-title">
          {t('otp-validation.bmg-error-modal.steps-title')}
        </p>

        <ol className="bmg-error-modal-client__steps">
          {STEPS.map((key) => (
            <li key={key} className="bmg-error-modal-client__step">
              <Trans
                i18nKey={`otp-validation.bmg-error-modal.${key}`}
                components={{
                  1: <span className="bmg-error-modal-client__platform" />
                }}
              />
            </li>
          ))}
        </ol>
      </div>

      <div className="bmg-error-modal-client__actions">
        <Button
          type="button"
          className="bmg-error-modal-client__button"
          onClick={onCancel}
          fullWidth
        >
          {t('otp-validation.cancel')}
        </Button>
        <Button
          type="button"
          className="bmg-error-modal-client__button"
          onClick={onRetry}
          variant="filled-black"
          fullWidth
        >
          {t('otp-validation.retry')}
        </Button>
      </div>
    </Modal>
  );
};

export default BmgErrorModal;
